require('./ContractConfirmationStep.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const {
    Component
} = require('react');
const classNames = require('classnames');

//@helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { findElementbyId } = require('routes/contractsView/utilities/contractStateHelper');
const contractBuilder = require('routes/contractsView/libs/contractBuilder');
const { toFirstUppercase } = require('utilities/stringHelper');
const { recordGdprClauseInteraction } = require('utilities/consentsHelper');
const get = require('lodash/object/get');

//@commons
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const { OKMessage } = require('commonsComponents/OKMessage');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const PreContractualDocumentViewer = require('components/commons/preContractualDocumentViewer/preContractualDocumentViewer');
// @components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');
const { PrinterPreviewManager } = require('components/contactCenter/printer/printerPreviewManager');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { EmptyState } = require('commonsComponents/emptyState');

// @ Loans
const { okLoansComponents } = require('ok-loans');
const ContractLoanPdfViewer = okLoansComponents.contractLoanPdfViewer;
// Local components
const ContractsConfirmationCheckboxGroup = require('../ContractsConfirmationCheckboxGroup/ContractsConfirmationCheckboxGroup');
const UserAddress = require('../userAddress/userAddress');
const PromoCode = require('../PromoCode/PromoCode');
//@constants
const {
    ACCOUNT_INTERVENTION_OWNER_CODE,
    ACCOUNT_INTERVENTION_LEGAL_REPRESENTATIVE_CODE,
    ACCOUNT_TYPE_E_LOAN,
    CONTRACT_INDEX_DEPOSIT_EXPIRATION,
    CONTRACT_INDEX_DEPOSIT_TRANSFER
} = require('constants/index');
const { COUNTRY_CODE_ES } = require('commonsConstants/countryCodes');
const {
    PROC_GDPR_CONSENTS_CONTRACTS,
    recordLink
    // PROC_END
} = require('utilities/tagging');
const {
    CHECKING_ACCOUNT_PRODUCT_ALIAS,
    E_ACCOUNT_LOAN_PRODUCT_ALIAS,
    OPEN_DEBIT_CARD_PRODUCT_MIN_ALIAS,
    R42_CARD_PRODUCT_MIN_ALIAS,
} = require('constants/hiringProductInformation');
//@ContactCenter
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const INTERVENERS = {
    '01': { order: 1, label: 'contractsView-intervenerTitular' },
    '08': { order: 2, label: 'contractsView-intervenerAuthorized' },
    '09': { order: 3, label: 'contractsView-intervenerLegalRepresentative' },
    '07': { order: 5, label: 'contractsView-intervenerRepresentative' },
    '25': { order: 6, label: 'contractsView-intervenerAdministrativeRepresentative' }
};

class ContractConfirmationStep extends Component {
    constructor(props) {
        super(props);

        this.buildOtpSection = this.buildOtpSection.bind(this);
    }

    componentDidMount() {
        const {
            current_contract,
            handleDocument,
            fetchPdfToPrint,
            hasContractPdfViewer,
            immAccounts,
            immProfileFields,
            immDeposits,
            contractWizard,
            pollingPDFMerge,
            sendPrecontractualDocumentMail,
            contractualPollingInitialization,
            operationProcessId,
            onComponentDidMountCallback
        } = this.props;
        const {
            product,
            standard,
            subtype,
            title,
            type,
        } = current_contract;
        const contractualAlias = current_contract.contractualAlias || contractWizard.getIn(['deposit_product', 'contractualAlias']);
        const productName = formatText(title);
        const originCountry = immProfileFields.get('originCountry');
        const nameContract = contractWizard.get('name_contract');

        let precontractualMailProductInfo = {
            productName,
            producto: type,
            standard,
            subproducto: subtype,
        };

        let precontractualMailProductInfoRelated = [{
            productAlias: OPEN_DEBIT_CARD_PRODUCT_MIN_ALIAS,
        }];

        let forceV2PrecontractualDocumentMailEndpoint = false;

        //If its Payroll Account but not an Upgrade To Payroll Account
        if (!!current_contract.accountAlias && current_contract.accountAlias === 'payroll_account' && !current_contract.onlyUpgradeableToPayroll) {
            precontractualMailProductInfo.productsRelated = precontractualMailProductInfoRelated;
        } else if ([CHECKING_ACCOUNT_PRODUCT_ALIAS, E_ACCOUNT_LOAN_PRODUCT_ALIAS].includes(product)) {
            precontractualMailProductInfo = {
                productAlias: product,
                productName,
            };

            if (product === CHECKING_ACCOUNT_PRODUCT_ALIAS) {
                //If origin country is Portugal or Germany R42 documentation should be used
                if (originCountry === 'PT' || originCountry === 'DE') {
                    precontractualMailProductInfoRelated = [{
                        productAlias: R42_CARD_PRODUCT_MIN_ALIAS,
                    }];
                }

                precontractualMailProductInfo.productsRelated = precontractualMailProductInfoRelated;
            }
        }

        if (current_contract.onlyUpgradeableToPayroll || nameContract === 'junior-account') {
            forceV2PrecontractualDocumentMailEndpoint = true;
        }

        !contractualAlias && sendPrecontractualDocumentMail(precontractualMailProductInfo, null, forceV2PrecontractualDocumentMailEndpoint);
        if (hasContractPdfViewer && handleDocument) {
            handleDocument.getHiringDocuments();
        }

        if (current_contract.needsPdfUrlFetching) {
            const params = contractBuilder[current_contract.officePrintedDocumentParamsFn](contractWizard, immProfileFields, immAccounts, immDeposits);
            fetchPdfToPrint(params);
        }

        if (!!contractualAlias) {
            if (!!operationProcessId) {
                pollingPDFMerge(operationProcessId);
            } else {
                if (['depositrenewal'].includes(nameContract)) {
                    contractualPollingInitialization(contractualAlias, contractWizard.get('precontractualDocumentId'));
                } else if ([ACCOUNT_TYPE_E_LOAN, CONTRACT_INDEX_DEPOSIT_EXPIRATION, CONTRACT_INDEX_DEPOSIT_TRANSFER].includes(nameContract)) {
                    const accountPrecontractualDicUrl = contractWizard.getIn(['mainAccount', 'data', 'accountConfig', 'precontractualDicUrl'])
                    contractualPollingInitialization(contractualAlias, contractWizard.get('precontractualDocumentId'), contractWizard.get('precontractualDocumentUrl'), {
                        precontractualDicUrl: accountPrecontractualDicUrl
                    });
                } else {
                    contractualPollingInitialization(contractualAlias);
                }
            }
        }
        onComponentDidMountCallback && onComponentDidMountCallback();
    }

    componentWillUnmount() {
        const { handleDocument, hasContractPdfViewer } = this.props;

        if (hasContractPdfViewer && handleDocument) {
            handleDocument.resetDocumentsAndAgreeCheckBox();
        }
    }

    buildFields(item, itemsDetails) {
        const { immProfileFields } = this.props;
        const itemValue = item.get('value');
        const itemLabel = item.get('label');
        const itemFormat = item.get('format_type');
        const itemDecimalsLength = item.get('decimalsLength');
        const injectedStringValues = item.get('injectedStringValues', null)
        const isNotNull = item.get('not_null', false)

        if (isNotNull && !itemValue) {
            return
        }
        
        switch (item.get('type')) {
            case 'single':
                let detailsValue;

                if (item.get('formatNumber')) {
                    const amountObj = {
                        currency: itemFormat,
                        amount: itemValue,
                        decimalsLength: itemDecimalsLength
                    };
                    const plainAmountObject = getPlainAmountObject(amountObj);

                    detailsValue = (
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                    );
                } else {
                    detailsValue = itemFormat ? `${itemValue} ${itemFormat}` : `${itemValue}`;
                    /**
                     * If we have the property isLanguageString that
                     * means we have a code to use a copy inside a
                     * FormattedText component.
                     */

                    if (item.get('isLanguageString') && !injectedStringValues) {
                        detailsValue = <FormattedText value={itemValue} />
                    }
                    if (item.get('isLanguageString') && !!injectedStringValues) {
                        detailsValue = <FormattedText value={itemValue} injectedStrings={injectedStringValues.toArray()} />
                    }
                    if (item.get('id') === 'address_data' && !detailsValue) {
                        detailsValue = <FormattedText value="contractsView-toDefine" />
                    }
                }

                itemsDetails[item.getIn(['confirmation_step', 'row']) - 1].push({
                    columns: item.getIn(['confirmation_step', 'columns']),
                    highlighted: item.getIn(['confirmation_step', 'highlighted']),
                    label: formatText(itemLabel),
                    order: item.getIn(['confirmation_step', 'order']),
                    value:
                        item.get('id') === 'cta_seleccionada'
                            ? item.get('description')
                            : detailsValue
                });
                break;

            case 'interveners':
                const { contractWizard } = this.props;
                const immInterveners = contractWizard.get('interveners');
                if (immInterveners) {
                    const juniorPersonalData = findElementbyId(contractWizard.get('card_details'), 'junior_form_personal_data');
                    const hasJunior = !!juniorPersonalData;
                    if (hasJunior) {
                        const juniorPersonalData = findElementbyId(
                            contractWizard.get('card_details'),
                            'junior_form_personal_data'
                        );
                        const juniorName = findElementbyId(juniorPersonalData, 'input-safe-name');
                        const lastName = findElementbyId(
                            juniorPersonalData,
                            'input-safe-last-name'
                        );
                        const secondLastName = findElementbyId(
                            juniorPersonalData,
                            'input-safe-second-last-name'
                        );
                        const titularName = `${juniorName} ${lastName} ${secondLastName || ''}`;

                        itemsDetails[item.getIn(['confirmation_step', 'row']) - 1].push({
                            columns: item.getIn(['confirmation_step', 'columns']),
                            highlighted: item.getIn(['confirmation_step', 'highlighted']),
                            label: formatText(INTERVENERS[ACCOUNT_INTERVENTION_OWNER_CODE].label),
                            order: INTERVENERS[ACCOUNT_INTERVENTION_OWNER_CODE].order,
                            value: titularName
                        });
                    }

                    const interveners = immInterveners.groupBy(item =>
                        hasJunior ? ACCOUNT_INTERVENTION_LEGAL_REPRESENTATIVE_CODE : item.get('typeNumber'));
                    interveners.forEach(field => {
                        const valueType = hasJunior ? ACCOUNT_INTERVENTION_LEGAL_REPRESENTATIVE_CODE : field.first().get('typeNumber');
                        itemsDetails[item.getIn(['confirmation_step', 'row']) - 1].push({
                            columns: item.getIn(['confirmation_step', 'columns']),
                            highlighted: item.getIn(['confirmation_step', 'highlighted']),
                            label: formatText(INTERVENERS[valueType].label),
                            order: INTERVENERS[valueType].order,
                            type: item.get('type'),
                            value: field
                                .toJS()
                                .map(valueDetail => {
                                    let name = valueDetail.name.split(" ").map((val) => {
                                        return toFirstUppercase(val);
                                    }).join(" ");

                                    return name;
                                })
                        });
                    });
                }
                break;

            case 'address':
                const buildExtraInfo = item.getIn(['confirmation_step', 'buildExtraInfo']);
                let extraInfo;

                if (buildExtraInfo) {
                    extraInfo = contractBuilder[buildExtraInfo]();
                }

                itemsDetails[item.getIn(['confirmation_step', 'row']) - 1].push({
                    columns: item.getIn(['confirmation_step', 'columns']),
                    extraInfo: extraInfo,
                    highlighted: item.getIn(['confirmation_step', 'highlighted']),
                    label: formatText(itemLabel),
                    order: item.getIn(['confirmation_step', 'order']),
                    type: item.get('type'),
                    value: (
                        <UserAddress
                            immProfileFields={immProfileFields}
                            modifier="confirmation-step"
                            ellipsisClass={true}
                        />
                    ),
                    valueTooltip: (
                        <UserAddress
                            immProfileFields={immProfileFields}
                            modifier="confirmation-step"
                        />
                    )
                });
                break;
        }
    }

    buildDetailText(text, detailClass, isValue, field, index, textTooltip) {
        const maxLength = field.columns * (isValue ? 7 : 8);
        const isNotIntervener = field.type !== 'interveners';
        let addressTooltip;
        let detailText = text;

        if (text.length > maxLength && isNotIntervener) {
            detailText = `${text.substr(0, maxLength - 3)}...`;
        }

        if (field.extraInfo && !isValue) {
            addressTooltip = (
                <OKTooltip
                    content={field.extraInfo}
                    offset={[0, -15]}
                />
            );
        }

        detailText = (
            <div key={`tooltip-${index}`} className={detailClass}>
                {detailText}
                {addressTooltip}
            </div>
        );
        textTooltip = textTooltip || text;

        if ((field.type === 'address' && isValue) || (text.length > maxLength && isNotIntervener)) {
            detailText = (
                <OKTooltip
                    content={textTooltip}
                    key={index}
                    offset={[0, -10]}
                    target={detailText}
                />
            );
        }

        return detailText;
    }

    builDetailField(field, index) {
        const detailsSectionClass = classNames(
            'contract-confirmation-step__field',
            `col-xs-${field.columns}`
        );
        const valueClass = classNames('contract-confirmation-step__value', {
            'contract-confirmation-step__value--highlight': field.highlighted
        });
        field.value = Array.isArray(field.value) ? field.value : [field.value];
        let value = field.value.map((detail, index) =>
            this.buildDetailText(detail, valueClass, true, field, index, field.valueTooltip)
        );
        let label = this.buildDetailText(
            field.label,
            'contract-confirmation-step__label',
            false,
            field
        );

        return (
            <div className={detailsSectionClass} key={index}>
                {label}
                {value}
            </div>
        );
    }

    buildItemsDetails(confirmationDetails, itemsDetails) {
        let numberOfRows = 1;
        confirmationDetails.forEach(item => {
            let itemRow = item.getIn(['confirmation_step', 'row']);
            numberOfRows = itemRow > numberOfRows ? itemRow : numberOfRows;
        });

        for (var i = 0; i < numberOfRows; i++) {
            itemsDetails.push([]);
        }

        return itemsDetails;
    }

    buildDetails() {
        const { contractWizard } = this.props;
        const immCardDetails = contractWizard.get('card_details');
        const confirmationDetails = immCardDetails.filter(details =>
            details.get('confirmation_step')
        );
        let itemsDetails = [];

        if (confirmationDetails.size > 0) {
            let details = [];

            itemsDetails = this.buildItemsDetails(confirmationDetails, itemsDetails);
            confirmationDetails.forEach(item => {
                this.buildFields(item, itemsDetails);
            });
            itemsDetails.forEach(row => row.sort((first, second) => first.order - second.order));
            itemsDetails = itemsDetails.map((row, index) => {
                details = row.map((item, index) => this.builDetailField(item, index));

                return (
                    <div className="contract-confirmation-step__row row" key={index}>
                        {details}
                    </div>
                );
            });
        }

        return itemsDetails;
    }

    showContactCenter() {
        const { initialStepHasLegalInformation, current_contract } = this.props;
        return !__CONTACT_CENTER__ || (__CONTACT_CENTER__ && !initialStepHasLegalInformation && !current_contract.notShowConfirmationCheckboxes);
    }

    buildCheckboxGroup(precontractualLink, updateConfirmationCheckboxes, confirmationCheckboxes, hasContractPdfViewer) {
        const {
            current_contract,
            customCategoryEvent,
            immMergePDFDocuments,
            contractWizard,
            getDocumentsOkApiById,
            getPrecontractualDocumentURLOrID,
            match,
            immProfileFields,
        } = this.props;

        let checkboxGroup = null;
        const originCountry = immProfileFields.get('originCountry');
        if (!hasContractPdfViewer && this.showContactCenter()) {
            checkboxGroup = (
                <ContractsConfirmationCheckboxGroup
                    contractWizard={contractWizard}
                    documentId={contractWizard.get('precontractualDocumentId')}
                    updateConfirmationCheckboxes={updateConfirmationCheckboxes}
                    confirmationCheckboxes={confirmationCheckboxes}
                    customCategoryEvent={customCategoryEvent}
                    getDocumentsOkApiById={getDocumentsOkApiById}
                    getPrecontractualDocumentURLOrID={getPrecontractualDocumentURLOrID}
                    precontractualLink={precontractualLink}
                    setTermsAndCondsText={this.props.setTermsAndCondsText}
                    match={match}
                    originCountry={originCountry}
                    areDisabled={current_contract.hasPolling && !immMergePDFDocuments.get('hasBeenFetched')}
                />
            );
        }
        return checkboxGroup;
    }

    buildViewer() {
        const { contractWizard, hasContractPdfViewer, handleDocument } = this.props;
        const getDocuments = get(handleDocument, 'getHiringDocuments');
        const document = contractWizard.get('document');
        const file = document.get('file');
        const agreeCheckbox = contractWizard.getIn(['confirmationCheckboxes', 'areValid']);
        const validate = document.get('showErrorMessage');
        const downloadError = document.get('downloadError');
        const loadingDownload = document.get('isFetchingZip');
        const isLoading = document.get('isFetchingDocuments');
        const errorLoading = document.get('errorDocuments');

        const poeditorPrefix = 'contractConfirmationStep';
        const title = formatText(`${poeditorPrefix}-${poeditorPrefix}_title`);
        const titleError = formatText('contractConfirmation-pdfError')
        const checkboxLabel = `${poeditorPrefix}-${poeditorPrefix}_agreeCheckboxLabel`;

        return (!__CONTACT_CENTER__ && hasContractPdfViewer) ? (
            <ContractLoanPdfViewer
                agreeCheckbox={agreeCheckbox}
                checkboxLabel={checkboxLabel}
                document={file}
                downloadError={downloadError}
                errorLoading={errorLoading}
                getDocuments={getDocuments}
                hasSignaturePattern
                isLoading={isLoading}
                loadingDownload={loadingDownload}
                onAgreeCheckbox={handleDocument.toggleAgree}
                onDownload={handleDocument.onDownloadDocument}
                onPrint={handleDocument.onPrintDocument}
                title={title}
                validate={validate}
            />
        ) : (
            <div>
                <EmptyState
                    primaryText={titleError}
                    iconType="noitems-banking" />
            </div>
        );
    }

    buildOtpSection() {
        const {
            gdprPlacementId,
            hasContractPdfViewer,
            params,
            signaturePatternCode,
            multiOTPMessageCode,
            contractWizard,
            customPrintDocument,
            bodyClass,
            printDocumentTranslations,
            handleSMSClick,
            customCategoryEvent,
            current_contract,
            immOfficePrintedDocument,
            handleSendNewOtp,
            handleInputSMSErrorTagging,
            handleSMSInputClickCallback,
        } = this.props;
        let isDocToPrintBase64 = null
        let officePrintDocument = null
        let isOfficePrintDocumentFetching = null
        let officePrintDocumentError = null

        if (immOfficePrintedDocument && current_contract) {
            isDocToPrintBase64 = current_contract.isPrintedDocBase64;
            officePrintDocument = immOfficePrintedDocument.get('document');
            isOfficePrintDocumentFetching = immOfficePrintedDocument.get('isFetching'); 
            officePrintDocumentError = immOfficePrintedDocument.get('error');
        }

        const agreeCheckbox = contractWizard.getIn(['confirmationCheckboxes', 'areValid']);
        const hideSignature = hasContractPdfViewer && !agreeCheckbox;
        let signaturePatternElement;

        if (signaturePatternCode) {

            if (gdprPlacementId) {
                signaturePatternElement = (
                    <GDPRSignaturePattern
                        operationType={signaturePatternCode}
                        operationParams={params}
                        multiOTPMessageCode={multiOTPMessageCode}
                        customPrintDocument={customPrintDocument}
                        pdfToShow={officePrintDocument}
                        isPdfToShowBase64={isDocToPrintBase64}
                        pdfToShowError={officePrintDocumentError}
                        pdfToShowFetching={isOfficePrintDocumentFetching}
                        bodyClass={bodyClass}
                        printDocumentTranslations={printDocumentTranslations}
                        handleSMSClick={handleSMSClick}
                        customEventCategory={customCategoryEvent}
                    />
                );
            } else {
                signaturePatternElement = (
                    <SignaturePattern
                        operationType={signaturePatternCode}
                        operationParams={params}
                        customEventCategory={customCategoryEvent}
                        customPrintDocument={customPrintDocument}
                        pdfToShow={officePrintDocument}
                        isPdfToShowBase64={isDocToPrintBase64}
                        pdfToShowError={officePrintDocumentError}
                        pdfToShowFetching={isOfficePrintDocumentFetching}
                        bodyClass={bodyClass}
                        printDocumentTranslations={printDocumentTranslations}
                        handleSMSClick={handleSMSClick}
                        onSMSInputClick={handleSMSInputClickCallback}
                        inputSMSErrorTagging={handleInputSMSErrorTagging}
                       {...(handleSendNewOtp && { onResendClick: handleSendNewOtp })}
                    />
                );
            }

            if (hideSignature) {
                signaturePatternElement = null;
            } else {
                signaturePatternElement = (
                    <section className="contract-confirmation-step__confirmation-section">
                        {signaturePatternElement}
                    </section>
                );
            }
        } else if (__CONTACT_CENTER__) {
            signaturePatternElement = (
                <section className="contract-confirmation-step__confirmation-section">
                    <PrinterPreviewManager customPrintDocument={customPrintDocument} bodyClass={bodyClass} printDocumentTranslations={printDocumentTranslations} pdfToShow={officePrintDocument} />
                </section>
            );
        }

        return signaturePatternElement;
    }

    onGdprAcceptAll(value) {
        recordGdprClauseInteraction(value, PROC_GDPR_CONSENTS_CONTRACTS)
    }

    onGdprChangeValue(id, value) {
        recordGdprClauseInteraction(value, PROC_GDPR_CONSENTS_CONTRACTS, id);
    }

    onGdprDisclaimerLinkClick(event) {
        const linkElement = event.target;
        if (linkElement) {
            recordLink(PROC_GDPR_CONSENTS_CONTRACTS, get(linkElement, 'attributes.data-title.value', ''));
        }
    }

    buildDepositCCWarning(context, date) {
        return (
            <div className="contract-confirmation-step__cc-warning-section">
                <OKMessage type="important">
                    <h5><FormattedText value="contractConfirmation-depositNMWarningTitle" /></h5>
                    <FormattedText value="contractConfirmation-depositNMWarningDescription" injectedStrings={[formatText(`${context}-${date}`)]} />
                </OKMessage>
            </div>
        )
    }

    buildPreContractPdfViewer() {
        const {
            showDepositAlertMessage,
            immProfileFields,
            preContractDocuments,
            contractWizard,
            current_contract,
            customCategoryEvent,
        } = this.props;
        const titleError = formatText('contractConfirmation-pdfError');
        const originCountry = immProfileFields.get('originCountry');

        let pdfTitleKey = 'preContractDocument_pdfTitlePrecontractual';
        let contractName = contractWizard.get('name_contract');
        let depositWarning;

        switch (contractName) {
            case 'junior-account':
                pdfTitleKey = 'preContractDocument_pdfTitleOpenYoung';
                break;
            case 'checking-account':
                pdfTitleKey = originCountry === COUNTRY_CODE_ES
                    ? 'preContractDocument_legalWindowCheckingAccountTitle'
                    : 'preContractDocument_pdfTitleCheckingAccount'
                break;
            case 'payroll-account':
                pdfTitleKey = originCountry === COUNTRY_CODE_ES
                    ? 'preContractDocument_payrollAccountLegalWindowTitle'
                    : 'preContractDocument_pdfTitlePayrollAccount'
                break;
            case 'upgrade-to-payroll-account':
                if (originCountry === COUNTRY_CODE_ES) {
                    pdfTitleKey = 'preContractDocument_upgradePayrollAccountLegalWindowTitle';
                }
            case 'depositnm':
                const context = contractWizard.getIn(['deposit_product', 'context']);
                const depositStartDate = contractWizard.getIn(['deposit_product', 'startDate']);
                if (isPrintOfficeMode() || !__CONTACT_CENTER__) {
                    depositWarning = showDepositAlertMessage(contractWizard) && (
                        <div className="contract-confirmation-step__field">
                            <OKMessage type="important">
                                <h5><FormattedText value="contractConfirmation-depositNMWarningTitle" /></h5>
                                <FormattedText value="contractConfirmation-depositNMWarningDescription" injectedStrings={[formatText(`${context}-${depositStartDate}`)]} />
                            </OKMessage>
                        </div>
                    )
                }
        }

        const pdfViewer = preContractDocuments ? (
            <div className="contract-confirmation-step__pdf-section">
                <PreContractualDocumentViewer
                    customCategoryEvent={customCategoryEvent}
                    preContractDocumentInfo={preContractDocuments}
                    titleKey={pdfTitleKey}
                    hasPolling={current_contract.hasPolling}
                    viewerHeight={611}
                />
                {depositWarning}
            </div>) :
            (
                <EmptyState
                    primaryText={titleError}
                    iconType="noitems-banking"
                />
            );

        return pdfViewer;
    }

    render() {
        const {
            alertMessage,
            cancelPromotionalCode,
            confirmationCheckboxes,
            confirmationLabel,
            confirmationMessage,
            contractWizard,
            current_contract,
            hasContractPdfViewer,
            gdprPlacementId,
            preContractDocuments,
            promoCodeEnabled,
            promotionalCodeAcceptanceChecboxChecked,
            promotionalCodeSetDirty,
            updateConfirmationCheckboxes,
            validatePromotionalCode,
            warningMessage,
            operativeName,
            showDepositAlertMessage,
            noWarningMessage,
            confirmationType
        } = this.props;
        const precontractualLink = contractWizard.get('precontractualLink');
        const checkboxGroup = this.buildCheckboxGroup(precontractualLink, updateConfirmationCheckboxes, confirmationCheckboxes, hasContractPdfViewer);
        const details = this.buildDetails();
        const otpSection = this.buildOtpSection();
        const showConsents = !!gdprPlacementId
        let consentsElement;
        let preContractPdfViewer = null;
        let isContractAccepted = true;
        if ((!__CONTACT_CENTER__ || (current_contract.notShowConfirmationCheckboxes && __CONTACT_CENTER__ && isPrintOfficeMode())) && !!preContractDocuments) {
            preContractPdfViewer = this.buildPreContractPdfViewer();

            const checkboxList = confirmationCheckboxes.get('list');
            isContractAccepted = checkboxList.getIn([0, 'value']);
        }

        if (showConsents) {
            consentsElement = (
                <OKConsents
                    placementId={gdprPlacementId}
                    handleAcceptAll={this.onGdprAcceptAll}
                    handleChangeValue={this.onGdprChangeValue}
                    handleDisclaimerLinkClick={this.onGdprDisclaimerLinkClick}
                />
            );
        }

        const promoCodeSection = promoCodeEnabled
            ? (<section className="contract-confirmation-step__confirmation-section">
                <PromoCode
                    promotionalCode={contractWizard.getIn(['promotionalCode', 'code']) || ''}
                    validatePromotionalCode={validatePromotionalCode}
                    promotionalCodeAcceptanceChecboxChecked={
                        promotionalCodeAcceptanceChecboxChecked
                    }
                    promotionalCodeSetDirty={promotionalCodeSetDirty}
                    cancelPromotionalCode={cancelPromotionalCode}
                    contractWizard={contractWizard}
                />
            </section>)
            : null;

        const message =
            confirmationMessage &&
            <div className="contract-confirmation-step__message-section">
                <OKMessage type="informative">
                    <FormattedText value={confirmationMessage.get('message')} />
                </OKMessage>
            </div>;
        const alert =
            alertMessage &&
            <div className="contract-confirmation-step__message-section">
                <OKMessage type="warning">
                    <FormattedText value={alertMessage} />
                </OKMessage>
            </div>;
        const context = contractWizard.getIn(['deposit_product', 'context']);
        const depositStartDate = contractWizard.getIn(['deposit_product', 'startDate']);
        const ccWarning = contractWizard.get('name_contract') === 'depositnm' && showDepositAlertMessage(contractWizard) && __CONTACT_CENTER__ && !isPrintOfficeMode() && this.buildDepositCCWarning(context, depositStartDate);
        return (
            <article>
                <header className="contract-confirmation-step__confirmation-header">
                    <h3>
                        <FormattedText value={confirmationLabel} />
                    </h3>
                </header>
                <section className="contract-confirmation-step__confirmation-section">
                    <ConfirmationScript operative={formatText(operativeName)} confirmationType={confirmationType ? confirmationType : CONFIRMATION_SCRIPT_GREETING} />
                    { !noWarningMessage && (
                        <div className="contract-confirmation-step__warning-message">
                            <FormattedText
                                value={warningMessage}
                                className="contract-confirmation-step__warning-message-text"
                            />
                        </div>
                    )
                    }
                    <div>
                        {details}
                    </div>
                    {message}
                    {consentsElement}
                    {preContractPdfViewer}
                    {checkboxGroup}
                    {alert}
                </section>
                {promoCodeSection}
                <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                {isContractAccepted ? otpSection : null}
                {ccWarning}
            </article>
        );
    }
}

ContractConfirmationStep.defaultProps = {
    confirmationLabel: 'contractsView-confirmationLabel',
    confirmationType: null,
    customCategoryEvent: undefined,
    fetchPdfToPrint: null,
    handleInputSMSErrorTagging: () => { },
    handleSMSClick: undefined,
    operationProcessId: null,
    customPrintDocument: null,
    bodyClass: '',
    printDocumentTranslations: null,
    noWarningMessage: false,
    onComponentDidMountCallback: () => { },
    handleSMSInputClickCallback: () => { },
};

ContractConfirmationStep.propTypes = {
    alertMessage: PropTypes.string,
    cancelPromotionalCode: PropTypes.func,
    confirmationCheckboxes: PropTypes.object,
    confirmationLabel: PropTypes.string,
    confirmationMessage: PropTypes.object,
    confirmationType: PropTypes.number,
    contractualPollingInitialization: PropTypes.func,
    contractWizard: PropTypes.object.isRequired,
    current_contract: PropTypes.object.isRequired,
    customCategoryEvent: PropTypes.string,
    dataReceiver: PropTypes.func,
    fetchPdfToPrint: PropTypes.func,
    showDepositAlertMessage: PropTypes.func,
    gdprPlacementId: PropTypes.string,
    getDocumentsOkApiById: PropTypes.func,
    handleDocument: PropTypes.object,
    handleSMSInputClickCallback: PropTypes.func,
    handleInputSMSErrorTagging: PropTypes.func,
    handleSMSClick: PropTypes.string,
    hasContractPdfViewer: PropTypes.bool,
    immAccounts: PropTypes.object,
    immDeposits: PropTypes.object,
    immMergePDFDocuments: PropTypes.object,
    immProfileFields: PropTypes.object,
    initialStepHasLegalInformation: PropTypes.bool,
    multiOTPMessageCode: PropTypes.number,
    immOfficePrintedDocument: PropTypes.object,
    noWarningMessage: PropTypes.bool,
    onComponentDidMountCallback: PropTypes.func,
    operationProcessId: PropTypes.string,
    operativeName: PropTypes.string,
    params: PropTypes.object,
    preContractDocuments: PropTypes.object,
    pollingPDFMerge: PropTypes.func,
    promoCodeEnabled: PropTypes.bool,
    promotionalCodeAcceptanceChecboxChecked: PropTypes.func,
    promotionalCodeSetDirty: PropTypes.func,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
    signaturePatternCode: PropTypes.number,
    updateConfirmationCheckboxes: PropTypes.func,
    validatePromotionalCode: PropTypes.func,
    warningMessage: PropTypes.string,
    customPrintDocument: PropTypes.string,
    bodyClass: PropTypes.string,
    printDocumentTranslations: PropTypes.object,
};

module.exports = ContractConfirmationStep;
